module.exports = __webpack_public_path__ + "static/media/main-visual-04-m.0c13d36.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-04-m.mp4
// module id = kTeU
// module chunks = 1